import { SoapUtils } from '../../../../utils/SoapUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface ICreateCompanyPersonRelationRequest extends IBaseRequest {
    EMPLOYEE:  Employee;
}

export interface Employee {
    id?:             string;
    contact?:        string;
    company?:        string;
    department?:     string;
    departmentInfo?: string;
    position?:       string;
    positionInfo?:   string;
    isPrimary?:      boolean;
    validFrom?:      Date;
    validTo?:        Date;
    type?:           string;
    originalName?:   string;
    custom1?:        string;
    custom2?:        string;
    custom3?:        string;
}

export function toEmployeeXml(emp:Employee): string{
    var xml = '';

    xml += SoapUtils.makeNode(emp.id, 'id');
    xml += SoapUtils.makeNode(emp.contact, 'contact');
    xml += SoapUtils.makeNode(emp.company, 'company');
    xml += SoapUtils.makeNode(emp.department, 'department');
    xml += SoapUtils.makeNode(emp.departmentInfo, 'departmentInfo');
    xml += SoapUtils.makeNode(emp.position, 'position');
    xml += SoapUtils.makeNode(emp.positionInfo, 'positionInfo');
    xml += SoapUtils.makeNode(emp.isPrimary, 'isPrimary');
    xml += SoapUtils.makeNode(emp.validFrom, 'validFrom');
    xml += SoapUtils.makeNode(emp.validTo, 'validTo');
    xml += SoapUtils.makeNode(emp.type, 'type');
    xml += SoapUtils.makeNode(emp.originalName, 'originalName');
    xml += SoapUtils.makeNode(emp.custom1, 'custom1');
    xml += SoapUtils.makeNode(emp.custom2, 'custom2');
    xml += SoapUtils.makeNode(emp.custom3, 'custom3');

    return `<EMPLOYEE>${xml}</EMPLOYEE>`;
}
export class CreateCompanyPersonRelationRequest extends BaseRequest implements ICreateCompanyPersonRelationRequest {
    public EMPLOYEE: Employee;
    constructor(server: string, session: string, employee: Employee) {
        super(server, session);
        this.EMPLOYEE = employee;
    }

    public toXml(): string {
        var parameters: string = super.toXml();
        parameters += toEmployeeXml(this.EMPLOYEE);
        return super.wrapperXml('CreateCompanyPersonRelation', parameters);
    }
}
